export const formatOfferDate = (date) => {
	if (!date) return "";

	return new Date(date).toLocaleDateString("en-GB", {
		day: "2-digit",
		month: "short",
	});
};
